<template>
  <forms-list-activity
      ref="budgetingPlannerListPM"
      :form-type="FORM_TYPE"
      :context="context"
      @selectedIndex="getSelectedIndex"
      :show-add="false"
      :show-delete="false"
      :items="items"
      :custom-data-loader="loadData"
      @export="exportRecordsToExcel"
      :stream-rows-post-process="formatterSummaryRow"
  >
  </forms-list-activity>
</template>

<script>
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsListContext from "@/activity/templates/layouts/forms/FormsListContext";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import Activity from "@/activity/Activity";
import CalculateBudgetingPlannerPMRecord from "@/components/forms/customizations/plm/CalculateBudgetingPlannerPMRecord";
import BudgetingPlanner from "@/server/com/silkplm/model/plm/BudgetingPlanner";
import Rpc from "@/Rpc";
import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import StreamingQuery from "@/components/forms/StreamingQuery";
import StreamingEngine from "@/components/forms/StreamingEngine";

const ImportDataToGrid = () => require("@/components/plm/ImportDataToGrid");
const BUDGETING_PLANNER_PM_LIST = "BUDGETING_PLANNER_PM_LIST";
const FORM_TYPE = BudgetingPlannerPM;
const CALC_PLANNER_PM = new CalculateBudgetingPlannerPMRecord();

export default {
  name: "BudgetingPlannerListPM",
  components: {FormsListActivity},
  // permission: () => FormsLoader.formPermission(FORM_TYPE),

  async mounted() {
    this.$onUpdate(BudgetingPlannerPM, async (changeEvent) => {
      await this.updateRow(changeEvent.instance);
      await this.updateSummaryRow(changeEvent.instance);
    });
    this.grid = this.$refs.budgetingPlannerListPM.$refs.entititesList.$refs.grid;
    this.grid.$on("refresh-meta-rq", () => {
      let selectedRecords = this.grid.localSelectedItems;
      for (let el of selectedRecords) {
        if (!el.productId) {
          el.__meta__.selected = false;
        }
      }
    });
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.$refs.budgetingPlannerListPM?.getTitle() ?? $tr('budgetPlannerListPM.planners', 'Budgeting planners PM');
    },

    getSelectedIndex(index) {
      this.selectedIndex = index;
    },

    async exportRecordsToExcel(props) {
      if (SessionManager.featureFlagsSet[FeatureFlag.STREAMING_LISTS]) {
        let showMultiSelect = props['showMultiSelect'];
        let streamingEngine = this.$refs.budgetingPlannerListPM.$refs.entititesList.streamingEngine;
        if (!showMultiSelect) {
          await Rpc.ExcelExports.exportBudgetingPlannerPMRecordsStreamingModeToExcelFileWithNoSelection(streamingEngine.query.toFormStreamingQuery()).lock();
        } else {
          let ids = props['items'];
          let includedUniqueIdentityForNullIds = props['streamSelection'].includedUniqueIdentityForNullIds;
          let excludedUniqueIdentityForNullIds = props['streamSelection'].excludedUniqueIdentityForNullIds;
          let allSelectedMode = props['streamSelection'].allSelectedMode;
          await Rpc.ExcelExports.exportBudgetingPlannerPMRecordsStreamingModeToExcelFileWithSelection(
              streamingEngine.query.toFormStreamingQuery(), ids,
              includedUniqueIdentityForNullIds, excludedUniqueIdentityForNullIds, allSelectedMode).lock();
        }
      } else {
        let recordsOrIds = props['items'];
        let recordsToExport = recordsOrIds?.length > 0 ? recordsOrIds : this.items;
        await Rpc.ExcelExports.exportBudgetingPlannerPMRecordsToExcelFile(recordsToExport).lock();
      }
    },

    async loadData(entitiesList, refreshOptions) {
      this.entitiesList = entitiesList;
      this.refreshOptions = refreshOptions;

      if (SessionManager.featureFlagsSet[FeatureFlag.STREAMING_LISTS]) {
        let sq = new StreamingQuery();
        sq.case = BUDGETING_PLANNER_PM_LIST;
        if (refreshOptions.hasFilters) {
          sq.colFilterSpec = refreshOptions.activeFilters;
          sq.textQuery = refreshOptions.textQuery;
        }
        // funkcja która mówi czy jak się zmienił rekord a to czy rekord b należy odświeżyć
        sq.refreshComparator = (a, b) => {
          if (!a?.productId || !b?.productId) { //summaryf
            return a?.seasonId === b?.seasonId && a?.categoryId === b?.categoryId;
          }
          return a?.id === b?.id;
        }
        return sq;
      }

      // let start = performance.now();
      /*
    let refreshOptions = {
      activeFilters: this.activeFilters,
      hasFilters: this.hasFilters,
    }
   */
      let listOfBudgetingPlannerPMSummaryRows;

      // filterSpecs: [
      //   {
      //     fieldName: "subSeasonId",
      //     fieldLabel: "season",
      //     filterSpec: {
      //       idValues: [subSeason.id],
      //       mergeTree: false
      //     }
      //   }
      let filters = [];
      if (refreshOptions?.hasFilters) {
        let form = FormsLoader.detectFormConfig(BudgetingPlanner);
        refreshOptions.activeFilters.forEach(value => {
          if (form.fields.find(value1 => {
            return value1.fieldLabel === value.fieldLabel
          })) {
            if (value.fieldName === "categoryId") {
              value.fieldName = "category"
            }
            if (value.fieldName === "budgetingPlannerIdPMResponsibleForTheGroup") {
              value.fieldName = "PMResponsibleForTheGroup";
            }
            filters.push(value);
          }
        });
      }
      // console.log(`P0: ${(performance.now() - start) / 1000} ms`);
      // start = performance.now();
      if (refreshOptions?.hasFilters && filters.length > 0) {
        listOfBudgetingPlannerPMSummaryRows = await Rpc.plm.services.BudgetingPlannerService
            .getBudgetingPlannerListPMSummaryRowsWithFilters(filters).lock();
      } else if (!refreshOptions?.hasFilters) {
        listOfBudgetingPlannerPMSummaryRows = await Rpc.plm.services.BudgetingPlannerService
            .getBudgetingPlannerListPMSummaryRows().lock();
      }
      // console.log(listOfBudgetingPlannerPMSummaryRows);
      // console.log(`P2: ${(performance.now() - start) / 1000} ms`);
      // start = performance.now();
      this.formatterSummaryRow(listOfBudgetingPlannerPMSummaryRows);
      // console.log(`P3: ${(performance.now() - start) / 1000} ms`);
      // start = performance.now();
      this.items = await this.filterRowsPlannerPM(listOfBudgetingPlannerPMSummaryRows, refreshOptions);
      // console.log(`P3: ${(performance.now() - start) / 1000} ms`);
      // start = performance.now();

      // await this.calculateSummaryRows();
      // console.log(`P4: ${(performance.now() - start) / 1000} ms`);
      // start = performance.now();
      return this.items;
    },

    formatterSummaryRow(records) {
      if (records && records.length) {
        for (let plannerPM of records) {
          let cellClasses = {};
          if (!plannerPM.productId) {
            plannerPM.__row_conf = {cssClass: "firstSummaryPMBudget", readOnly: true};
          }
        }
      }
    },

    async getAllProductsInSeasonInfo() {
      let allProductsInSeason = await Rpc.plm.services.ProductService.getAllProductInSeason().lock();
      let listOfProductsInfo = [];

      for (let productInSeason of allProductsInSeason) {
        let product = await productInSeason.getProductIdEntity();
        let productCategory = await product.getCategoryEntity();
        listOfProductsInfo.push({
          productInSeason: productInSeason,
          approval: productInSeason.approvalToCollection,
          planningList: productInSeason.targetPlanningProduct,
          product: product,
          productCategory: productCategory
        });
      }
      return listOfProductsInfo;
    },

    async findPlannersWithProducts(refreshOptions) {
      let start = performance.now();
      let listOfAllBudgetingPlannerPMWithProduct;
      if (refreshOptions?.hasFilters) {
        for (let filter of refreshOptions.activeFilters) {
          if (filter.fieldName === "category") {
            filter.fieldName = "categoryId";
          }
          if (filter.fieldName === "PMResponsibleForTheGroup") {
            filter.fieldName = "budgetingPlannerIdPMResponsibleForTheGroup";
          }
        }
        listOfAllBudgetingPlannerPMWithProduct = await Rpc.plm.services.BudgetingPlannerService
            .getAllBudgetingPlannerPMWithProductWithFilters(refreshOptions.activeFilters).lock();
      } else {
        listOfAllBudgetingPlannerPMWithProduct = await Rpc.plm.services.BudgetingPlannerService
            .getAllBudgetingPlannerPMWithProduct().lock();
      }
      return listOfAllBudgetingPlannerPMWithProduct;
    },

    async filterRowsPlannerPM(listOfBudgetingPlannerPMSummaryRows, refreshOptions) {
      let start = performance.now();
      let listOfAllBudgetingPlannerPMWithProduct;
      if (refreshOptions?.hasFilters) {
        for (let filter of refreshOptions.activeFilters) {
          if (filter.fieldName === "category") {
            filter.fieldName = "categoryId";
          }
          if (filter.fieldName === "PMResponsibleForTheGroup") {
            filter.fieldName = "budgetingPlannerIdPMResponsibleForTheGroup";
          }
        }
        listOfAllBudgetingPlannerPMWithProduct = await Rpc.plm.services.BudgetingPlannerService
            .getAllBudgetingPlannerPMWithProductWithFilters(refreshOptions.activeFilters).lock();
      } else {
        listOfAllBudgetingPlannerPMWithProduct = await Rpc.plm.services.BudgetingPlannerService
            .getAllBudgetingPlannerPMWithProduct().lock();
      }
      // console.log(`X1: ${(performance.now() - start ) /1000} ms` );
      // start = performance.now();
      let listOfAllBudgetingPlannerPMWithApproval = [];
      for (let plannerWithProduct of listOfAllBudgetingPlannerPMWithProduct) {
        let productInSeason = await plannerWithProduct.getProductIdEntity();

        // let plannerWithProduct = el.budgetingPlannerPM;
        // let productInSeason = el.productInSeason;


        if (productInSeason.approvalToCollection) {
          if (productInSeason.targetPlanningProduct.length) {
            for (let i = 0; i < productInSeason.targetPlanningProduct.length; i++) {
              if (plannerWithProduct.supplierId === productInSeason.targetPlanningProduct[i].supplierId) {
                listOfAllBudgetingPlannerPMWithApproval.push(plannerWithProduct);
              }
            }
          } else {
            listOfAllBudgetingPlannerPMWithApproval.push(plannerWithProduct);
          }
        }
      }
      // console.log(`X2: ${(performance.now() - start ) /1000} ms` );
      // start = performance.now();
      let result = [];

      if (listOfBudgetingPlannerPMSummaryRows && listOfBudgetingPlannerPMSummaryRows.length) {
        for (let plannerPM of listOfBudgetingPlannerPMSummaryRows) {
          result.push(plannerPM);
          let matchedPlanners = [];
          for (let plannerPMWithProduct of listOfAllBudgetingPlannerPMWithApproval) {
            if (plannerPMWithProduct.seasonId === plannerPM.seasonId
                && plannerPMWithProduct.categoryId === plannerPM.categoryId) {
              result.push(plannerPMWithProduct);
              matchedPlanners.push(plannerPMWithProduct);
            }
          }
          listOfAllBudgetingPlannerPMWithApproval = listOfAllBudgetingPlannerPMWithApproval.filter(el => !matchedPlanners.includes(el));
        }
      }
      // console.log(`X3: ${(performance.now() - start ) /1000} ms` );
      // start = performance.now();
      if (result.length === 0 && refreshOptions?.hasFilters) {
        result = [...listOfAllBudgetingPlannerPMWithApproval];
      }

      return result;
    },

    async updateRow(instance) {
      await CALC_PLANNER_PM.calculatePlannerWithProduct(instance);
    },

    async updateSummaryRow(instance) {
      let quantityPOS = null;
      let onlineQuantity = null;
      let totalQuantity = null;

      let summaryIndex = null;
      for (let index = 0; index < this.items.length; index++) {
        if (this.items[index].budgetingPlannerId === instance.budgetingPlannerId) {
          if (this.items[index].productId === 0) {
            summaryIndex = index;
          } else {
            quantityPOS += this.items[index].quantityPOS;
            onlineQuantity += this.items[index].onlineQuantity;
            totalQuantity += this.items[index].totalQuantity;
          }
        }
      }
      if (!this.items[summaryIndex]) {
        return;
      }
      this.items[summaryIndex].quantityPOS = quantityPOS;
      this.items[summaryIndex].onlineQuantity = onlineQuantity;
      this.items[summaryIndex].__computed__.totalQuantity = totalQuantity;

      this.$refs.budgetingPlannerListPM.$refs.entititesList.$refs.grid.items[summaryIndex] = this.items[summaryIndex];
      this.$refs.budgetingPlannerListPM.$refs.entititesList.$refs.grid?.refreshIndex(summaryIndex);
    }
  },

  props: {
    context: {
      default:
          null
    },
  },

  data: function () {
    return {
      items: [],
      selectedIndex: null,
      FORM_TYPE,
      entitiesList: null,
      refreshOptions: {default: null},
      streaming: false,
    }
  },

}

</script>
